import type { SyncLatestResponse } from '@mathflat/domain/@entities/Guest/guest.dto'
import type { Guest } from '@mathflat/domain/@entities/Guest/type'
import type { QueryClient } from '@tanstack/react-query'

import { guestApi } from '@/api/guest.api'

import queryClient from './queryClient'

export const guestsQuery = {
  queryKey: ['guests'] as const,
  queryFn: () => guestApi.getGuests().then((res) => res.data),
  // 비재원생은 sync 로만 갱신되므로 길게 캐시해 중복 GET 을 막는다.
  staleTime: 1000 * 60,
}

export const latestGuestSyncQuery = {
  // 'guests' prefix 를 쓰면 invalidateQueries(['guests'])의 prefix 매칭에 휘말려 echo 로 채운 캐시가 즉시 refetch 로 덮인다
  queryKey: ['guest-sync', 'latest'] as const,
  queryFn: () => guestApi.getLatestSync().then((res) => res.data),
}

export const guestController = {
  prefetchGuests: () => queryClient.prefetchQuery(guestsQuery),
  fetchGuests: () => queryClient.fetchQuery(guestsQuery),
  getCachedGuests: () => queryClient.getQueryData<Guest[]>(guestsQuery.queryKey),
  invalidateGuests: () => queryClient.invalidateQueries({ queryKey: guestsQuery.queryKey }),
  // 화면이 구독하는 클라이언트에서 캐시를 갱신해야 하므로 client 를 호출부에서 받는다.
  syncGuests: async (client: QueryClient) => {
    const { data } = await guestApi.sync()
    // GET 한 번 결과를 두 캐시에 직접 반영한다 — invalidate 로는 클라이언트마다 개별 refetch 해 중복 GET 이 났다.
    const guests = await guestApi.getGuests().then((res) => res.data)
    client.setQueryData<Guest[]>(guestsQuery.queryKey, guests)
    queryClient.setQueryData<Guest[]>(guestsQuery.queryKey, guests)
    // 명단 갱신까지 성공한 뒤 SUCCESS 로 기록한다 — getGuests 실패 시 동기화 상태와 캐시가 어긋나지 않도록.
    client.setQueryData<SyncLatestResponse>(latestGuestSyncQuery.queryKey, {
      status: 'SUCCESS',
      syncedAt: data.syncedAt,
    })
  },
}
